import { GAWrapperEvent } from "utilities/GAWrapper";
import { KAEvent } from "utilities/KAWrapper";

import { ANALYTICS } from "analytics";

export const TrackAnalytics = params => {
  const { category, action } = params;
  GAWrapperEvent({
    category: category || ANALYTICS.CATEGORY.ALL,
    action
  });
  KAEvent({
    n: action
  });
};
